import React from 'react';
import config from "../config"

const Footer = () => (
  <footer>
    <p>&copy; 2026 {config.companyName}</p>
  </footer>
);

export default Footer;